/* eslint-disable  */
const deserializer = (data, edit= 'false') => {
	const newData = data?.map((item) => {
		return {
			...(edit === 'true' && item?.id ? {id: item?.id} : {}),
			active: item?.active,
			productName: item?.productName,
			variantId: item?.variantId,
			variantName: item?.variantName,
			vendorId: Number(item?.buyerId),
			vendorSystemVariantId: item?.buyerSystemItemId,
		};
	});
	return newData;
};
const serializer = (rawData, productList) => {
	const newData = rawData?.map((item) => {
		const product = productList?.find((prod) => prod?.variants?.some((variant) => variant?.id === item?.variantId));
		return {
			...(item?.id && {id: item?.id}),
			productId: product?.id,
			productName: item?.productName,
			variantId: item?.variantId,
			variantName: item?.variantName,
			unit: product?.purchaseUnit ?? product?.unit,
			buyerSystemItemId: item?.vendorSystemVariantId,
			active: item?.active,
			buyerId: item?.vendorId
		};
	});
	return newData;
};

const validation = (data) => {
	const errors = {};
	data?.forEach((item, index) => {
		if(!item?.buyerSystemItemId){
			errors[index] = 'Please note: Buyer system item ID is currently empty';
		}
	});
	return errors;
};

const config = {
	deserializer,
	serializer,
	validation,
};

export default config;
